function selectedCurrency() {
	const defaultCurrency = {
		locales: env.LOCALES,
		currency: env.CURRENCY,
		rate: 1
	}
	let navigatorCurrency = null
	const navigatorLanguage = navigator.language
	const numberFormat = Object.values(env.numberFormat)

	for (const item of numberFormat) {
		if (navigatorLanguage.indexOf(item.locales) > -1) {
			navigatorCurrency = item
			break
		}
	}

	if (navigatorCurrency === null) {
		navigatorCurrency = defaultCurrency
	}

	return localStorage.getItem('commodity_currency') === '1'
		? defaultCurrency
		: navigatorCurrency
}

export function convertedAmount(amount, currency) {
	const numericAmount = Number(amount)
	if (!Number.isFinite(numericAmount)) {
		return 0
	}

	return String(currency).toUpperCase() === 'USD'
		? numericAmount
		: (numericAmount < 0 ? Math.ceil(numericAmount) : Math.floor(numericAmount))
}

export function formatConvertedCurrency(amount) {
	const language = selectedCurrency()
	const rateAmount = convertedAmount(Number(amount) * Number(language.rate), language.currency)
	const options = {
		style: 'currency',
		currency: language.currency
	}

	if (String(language.currency).toUpperCase() !== 'USD') {
		options.minimumFractionDigits = 0
		options.maximumFractionDigits = 0
	}

	return new Intl.NumberFormat(language.locales, options).format(rateAmount)
}
